/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import {
    CLEAR_STATE,
    REQUEST_FLEETS_HIERARCHY,
    RECEIVE_FLEETS_HIERARCHY,
    REQUEST_FLEET,
    RECEIVE_FLEET,
    SUBMIT_FLEET,
    GENERAL_RECEIVE,
    SET_FLEET_ATTRIBUTE
} from "./FleetsActions";

const initialState = {
    error: null,
    loading: false,
    fleetsHierarchy: [],
    fleet: {
        id: null,
        name: '',
        parentId: null,
    },
}

export const fleetsReducer = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_FLEET:
        case REQUEST_FLEETS_HIERARCHY:
            return {
                ...state,
                loading: true,
            }
        case RECEIVE_FLEETS_HIERARCHY:
            return {
                ...state,
                loading: false,
                fleetsHierarchy: action.fleets,
            }
        case SUBMIT_FLEET:
            return {
                ...state,
                loading: true,
                fleet: action.fleet,
            }
        case RECEIVE_FLEET:
            return {
                ...state,
                loading: false,
                fleet: {
                    ...action.fleet,
                    parentId: 'fleet_' + action.fleet.parentId,
                },
            }
        case GENERAL_RECEIVE:
            return {
                ...state,
                loading: false,
            }
        case SET_FLEET_ATTRIBUTE:
            const newState = {
                ...state,
            }

            const newFleet = {}
            newFleet[action.key] = action.value
            newState.fleet = Object.assign({}, newState.fleet, newFleet)
            return newState
        case CLEAR_STATE:
            return initialState
        default:
            return state
    }
}